import { Component } from 'react';
import { Link } from 'react-router';

import Icon, { icons } from '../generic/Icon';

class TodoItem extends Component<
  {
    params?: any;
    key?: string;
    text?: any;
    refs?: any[];
    filterKey?: string;
    href?: string;
    noCaret?: boolean;
    pending?: boolean;
    expanded?: boolean;
    onClick?: Function;
    className?: string;
  },
  any
> {
  onClickItem = () => {
    this.props.onClick(this.props.filterKey || this.props.text, {
      title: this.props.text,
      refs: this.props.refs,
    });
  };

  render() {
    var ItemClass = this.props.href ? Link : 'div';
    return (
      <li
        className={
          (this.props.expanded ? 'active' : '') +
          ' ' +
          (this.props.pending ? 'pending' : '') +
          ' ' +
          (this.props.className || '')
        }>
        <ItemClass to={this.props.href}>
          <div className="attr-head" onClick={this.onClickItem}>
            {!this.props.noCaret ? (
              <span>
                <Icon icon={icons.caretRight} />
              </span>
            ) : (
              ''
            )}{' '}
            <span>{this.props.text}</span>
            {this.props.pending ? <span className="label label-success pull-right">In Review</span> : ''}
          </div>
        </ItemClass>
        {this.props.expanded ? this.props.children : ''}
      </li>
    );
  }
}
export default TodoItem;
